export class RmRackPositionIdRequestDto{
    rmRackPositionId:number;
    constructor(rmRackPositionId:number){
        this.rmRackPositionId = rmRackPositionId;
    }
}